<template>
    <div class="error-msg-wrap">
        <div v-if="!showSig && loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div style="display:flex">
                <input type="text" style="width:180px" v-model="searchQ" @input="search()" placeholder="Search" />
            </div>
            <table class="full-table">
                <tr v-for="(sig, i) in signatures" :key="i">
                    <td>{{ sig.UpdatedDateDisplay }}</td>
                    <td><a @click.prevent="viewSigs(sig)">{{ sig.UserName }}</a></td>
                </tr>
            </table>
        </div>

        <div v-if="showSig" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="() => { showSig = false }">&times;</button>
            </div>
            <div v-for="(sig, i) in sigToView.SignOffs" :key="i" style="margin-bottom:10px">
                <div style="margin-bottom:5px"><b>{{ sig.name }}</b></div>
                <div><img :src="sig.signatureData" /></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'OnboardingSignatures',
    props: ['onboardingProp'],
    data() {
        return {
            onboarding: {} as any,
            loaded: false,
            signatures: [] as any,
            allSignatures: [] as any,
            sigToView: null as any,
            showSig: false,
            searchQ: ''
        }
    },
    async created() {
        this.onboarding = JSON.parse(JSON.stringify(this.onboardingProp));
        
        await axios.get(`${this.$store.state.apiUrl}/api/onboardings/allsignoffs/${this.onboarding.ID}`)
            .then(resp => {
                for(const sig of resp.data) {
                    if(sig.UpdatedDate) {
                        sig.UpdatedDateDisplay = new Date(sig.UpdatedDate).toLocaleDateString();
                    }
                    if(sig.SignOffsJSON) {
                        sig.SignOffsJSON = JSON.parse(sig.SignOffsJSON);
                    } else {
                        sig.SignOffsJSON = {};
                    }
                    sig.SignOffs = [];
                    for(const step of this.onboarding.StepsJSON) {
                        if(sig.SignOffsJSON[step.id]) {
                            sig.SignOffs.push({
                                signatureData: sig.SignOffsJSON[step.id].signatureData,
                                name: step.name
                            })
                        }
                    }
                }
                this.allSignatures = resp.data;
                this.signatures = resp.data;
            })
            .catch(e => {
                console.log(e);
            })

        this.loaded = true;
    },
    methods: {
        viewSigs(sig: any) {
            this.sigToView = sig;
            this.showSig = true;
        },
        search() {
            if(this.searchQ.length < 3) {
                this.signatures = this.allSignatures;
            } else {
                const searchQLower = this.searchQ.toLowerCase();
                this.signatures = this.allSignatures.filter((s: any) => {
                    return s.UserName && s.UserName.toLowerCase().includes(searchQLower);
                })
            }
        }
    }
})
</script>